(function(){
  if(window.__bclpInit) return;
  window.__bclpInit = true;

  function init(){
    document.querySelectorAll('[data-bclp-countdown]').forEach(function(cd){
      var mins = parseInt(cd.getAttribute('data-mins'),10) || 15;
      var key = 'bclp_cd_' + mins;
      var end = parseInt(sessionStorage.getItem(key),10);
      if(!end || isNaN(end) || end < Date.now()){ end = Date.now() + mins*60000; sessionStorage.setItem(key, end); }
      var h=cd.querySelector('[data-h]'), m=cd.querySelector('[data-m]'), s=cd.querySelector('[data-s]');
      function pad(n){return (n<10?'0':'')+n;}
      function tick(){
        var d=Math.max(0,end-Date.now()), t=Math.floor(d/1000);
        if(h) h.textContent=pad(Math.floor(t/3600));
        if(m) m.textContent=pad(Math.floor((t%3600)/60));
        if(s) s.textContent=pad(t%60);
        if(d<=0){ end=Date.now()+mins*60000; sessionStorage.setItem(key,end); }
      }
      tick(); setInterval(tick,1000);
    });

    document.querySelectorAll('.bclp__pform').forEach(function(form){
      var idInput = form.querySelector('[data-bclp-id]');
      var card = form.closest('.bclp__card');
      var priceEl = card ? card.querySelector('[data-bclp-price]') : null;
      var compareEl = card ? card.querySelector('[data-bclp-compare]') : null;
      form.querySelectorAll('input[type=radio]').forEach(function(r){
        r.addEventListener('change', function(){
          if(idInput) idInput.value = r.value;
          if(priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
          if(compareEl){ compareEl.textContent = (r.dataset.compare && r.dataset.compare !== r.dataset.price) ? r.dataset.compare : ''; }
        });
      });
    });

    document.querySelectorAll('[data-bclp-vid]').forEach(function(box){
      var v = box.querySelector('video');
      if(!v) return;
      box.addEventListener('click', function(){
        if(v.paused){
          document.querySelectorAll('[data-bclp-vid] video').forEach(function(o){ if(o!==v){ o.pause(); o.closest('[data-bclp-vid]').classList.remove('is-playing'); } });
          v.play(); box.classList.add('is-playing');
        } else { v.pause(); box.classList.remove('is-playing'); }
      });
    });

    document.querySelectorAll('[data-bclp-vslider]').forEach(function(sl){
      var track = sl.querySelector('[data-bclp-vtrack]');
      var prev = sl.querySelector('[data-bclp-vprev]');
      var next = sl.querySelector('[data-bclp-vnext]');
      if(!track) return;
      function amount(){ return Math.max(track.clientWidth * 0.8, 240); }
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({ left: amount(), behavior: 'smooth' }); });
      function upd(){
        var sMax = track.scrollWidth - track.clientWidth - 2;
        if(sMax <= 0){ if(prev) prev.hidden = true; if(next) next.hidden = true; return; }
        if(prev) prev.hidden = track.scrollLeft <= 2;
        if(next) next.hidden = track.scrollLeft >= sMax;
      }
      track.addEventListener('scroll', upd);
      window.addEventListener('resize', upd);
      upd();
    });

    document.querySelectorAll('[data-bclp-featured]').forEach(function(root){
      var dataEl = root.querySelector('[data-bclp-variants]');
      if(!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }

      var idInput = root.querySelector('[data-bclp-id]');
      var priceEl = root.querySelector('[data-bclp-price]');
      var compareEl = root.querySelector('[data-bclp-compare]');
      var mainImg = root.querySelector('[data-bclp-main-img]');
      var buyBtn = root.querySelector('[data-bclp-buy]');
      var soldEl = root.querySelector('[data-bclp-sold]');

      function currentSelection(){
        var vals = [];
        root.querySelectorAll('.bclp__opt').forEach(function(o){
          var c = o.querySelector('input:checked');
          vals.push(c ? c.value : null);
        });
        return vals;
      }

      function apply(){
        var sel = currentSelection();
        var match = variants.find(function(v){
          if(!v.options || v.options.length !== sel.length) return false;
          return v.options.every(function(o,i){ return o === sel[i]; });
        });
        if(!match) return;
        if(idInput) idInput.value = match.id;
        if(priceEl && match.price) priceEl.textContent = match.price;
        if(compareEl){ compareEl.textContent = (match.compare && match.compare !== match.price) ? match.compare : ''; }
        if(mainImg && match.img){ mainImg.src = match.img; }
        if(match.available){
          if(buyBtn) buyBtn.style.display = '';
          if(soldEl) soldEl.style.display = 'none';
        } else {
          if(buyBtn) buyBtn.style.display = 'none';
          if(soldEl) soldEl.style.display = '';
        }
      }

      root.querySelectorAll('.bclp__opt input[type=radio]').forEach(function(r){
        r.addEventListener('change', apply);
      });

      root.querySelectorAll('[data-bclp-thumb]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(mainImg) mainImg.src = btn.getAttribute('data-img');
          root.querySelectorAll('[data-bclp-thumb]').forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      var qty = root.querySelector('[data-bclp-qty]');
      if(qty){
        var minus = root.querySelector('[data-bclp-qminus]');
        var plus = root.querySelector('[data-bclp-qplus]');
        if(minus) minus.addEventListener('click', function(){ qty.value = Math.max(1, (parseInt(qty.value,10)||1) - 1); });
        if(plus) plus.addEventListener('click', function(){ qty.value = (parseInt(qty.value,10)||1) + 1; });
      }

      apply();
    });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();